/**
 *  상품 주문을 선택해주세요.
 */
export const INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE = '상품 주문을 선택해주세요.';

/**
 *  발송기한을 선택해주세요.
 */
export const INVALID_REQUIRED_DELIVERY_PERIOD_MESSAGE = '발송기한을 선택해주세요.';

/**
 *  환불 예정 금액은 0원 이상입니다.
 */
export const INVALID_MINIMUM_REFUND_AMOUNT_MESSAGE = '환불 예정 금액은 0원 이상입니다.';

/**
 *  환불 예정 금액은 고객 결제 금액보다 클 수 없습니다.
 */
export const INVALID_MAXIMUM_REFUND_AMOUNT_MESSAGE = '환불 예정 금액은 고객 결제 금액보다 클 수 없습니다.';

/**
 * 브랜드 분할 다운로드는 7일 보다 크면 서버의 부하를 줄이기 위해 거부함
 */
export const INVALID_SPLIT_DOWNLOAD_PERIOD =
  '브랜드별 파일 구분 다운로드는 조회 기간을 7일 이내로 검색 후에 가능합니다';
